module.exports = __webpack_public_path__ + "static/img/image.1745385299907.jpg";